import React, { useLayoutEffect } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox } from "components"
import classes from "./CheckoutPrintCustomerReceipt.module.scss"

const CheckoutPrintCustomerReceipt = (props) => {
  const {
    printCustomerReceipt,
    setPrintCustomerReceipt
  } = props

  const [t, i18n] = useTranslation()

  const handleCheck = (checked) => {
    setPrintCustomerReceipt(checked)

    localStorage.setItem(
      "printCustomerReceipt",
      String(checked)
    )
  }

  const initialCheckboxValue = () => {
    const printCustomerReceipt =
      localStorage.getItem("printCustomerReceipt")

    if (printCustomerReceipt === null) return

    setPrintCustomerReceipt(
      printCustomerReceipt === "true"
    )
  }

  useLayoutEffect(() => {
    initialCheckboxValue()
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["print"]}>
      <Checkbox
        checked={printCustomerReceipt}
        onChange={handleCheck}
      />
      <span
        className={clsx(
          classes["print-label"],
          isLtr && classes["print-label-ltr"]
        )}
      >
        {t("پرینت_رسید_مشتری")}
      </span>
    </div>
  )
}

export default CheckoutPrintCustomerReceipt